export const buildQueryString = (query: Record<string, any>) =>
  Object.entries(query).reduce(
    (out, [key, value]) => (value ? `${out ? `${out}&` : out}${key}=${encodeURIComponent(value)}` : out),
    '',
  );
